import * as React from 'react';
import { cn } from '@/lib/utils';
import { FilterRow } from './filter';
import { Label } from '@/components/ui/label';
import { ComboboxSingle } from '@/components/ui/combobox-single';
import { ComboboxMultiple } from '@/components/ui/combobox-multiple';

export const FilterCombobox = React.forwardRef(
  (
    {
      // props
      id,
      className,
      options = [],
      placeholder = 'Selecione...',
      loading = false,
      emptyMessage = 'Nenhum resultado encontrado.',
      label = '',
      multiple = false,
      fullWidth,
      disabled = false,
      ...props
    },
    ref
  ) => {
    const generatedId = React.useId();
    const filterId = id || generatedId;

    return (
      <FilterRow
        ref={ref}
        className={cn(fullWidth ? 'md:w-full' : null, className)}
      >
        {label && <Label htmlFor={filterId}>{label}</Label>}
        {multiple ? (
          <ComboboxMultiple
            id={filterId}
            options={options}
            placeholder={placeholder}
            loading={loading}
            emptyMessage={emptyMessage}
            disabled={disabled}
            {...props}
          />
        ) : (
          <ComboboxSingle
            id={filterId}
            options={options}
            placeholder={placeholder}
            loading={loading}
            emptyMessage={emptyMessage}
            disabled={disabled}
            {...props}
          />
        )}
      </FilterRow>
    );
  }
);

FilterCombobox.displayName = 'FilterCombobox';
